
import blogItemProps from '~/modules/blog-item-props';

export default {
  name: 'MktBlogItemCompact',
  props: { ...blogItemProps() },
};
